import DashboardIcon from "@mui/icons-material/Dashboard";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { People } from "@mui/icons-material";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { MenuItems } from "../../interface/menuItemsInterface";
import SettingsIcon from "@mui/icons-material/Settings";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import AccountTreeIcon from '@mui/icons-material/AccountTree';

const adminSideBarItems: MenuItems[] = [
    {
        i: 1,
        name: "Dashboard",
        icon: <DashboardIcon />,
        link: "/",
    },
    {
        i: 3,
        name: "Holidays",
        icon: <BeachAccessIcon />,
        link: "/holidays",
        subitems: [
            {
                i: 4,
                name: "Add Holiday",
                icon: <CalendarMonthIcon />,
                link: "/holidays/addholiday",
            },
            {
                i: 14,
                name: "Handle Holidays",
                icon: <BeachAccessIcon />,
                link: "/holidays/manageholiday",
            },
            {
                i: 13,
                name: "National Holidays",
                icon: <SettingsIcon />,
                link: "/holidays/nationalholidays",
            },
        ],
    },

    {
        i: 5,

        name: "Documents",
        icon: <InsertDriveFileIcon />,
        link: "/documents",
    },
    {
        i: 6,
        name: "Skills review",
        icon: <AssessmentIcon />,
        link: "/skills",
        subitems: [
            {
                i: 7,
                name: "My Skills",
                link: "/skills/edit",
                icon: <ListAltIcon />,
            },
            {
                i: 8,
                name: "List",
                icon: <ManageSearchIcon />,
                link: "/skills/list",
            },
        ],
    },
    {
        i: 7,
        name: "Users",
        icon: <People />,
        link: "/users",
    },
    {
        i: 10,
        name: "Clients",
        icon: <BusinessCenterIcon />,
        link: "/clients",
    },
    {
        i: 12,
        name: "Organizations",
        icon: <AccountTreeIcon />,
        link: "/organizations",
    },
    {
        i: 11,
        name: "Home Office",
        icon: <HomeWorkIcon />,
        link: "/home_office",
    },
    {
        i: 15,
        name: "Logout",
        icon: <PowerSettingsNewIcon />,
        link: "/#",
    },
];

export default adminSideBarItems;
